if (!customElements.get('size-guide')) {
  customElements.define('size-guide', class SizeGuide extends ModalDialog {});
}

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-size-guide-trigger]');
  if (!trigger) return;
  /* ModalDialog's connectedCallback moves <size-guide> to the end of
     document.body on page load, so it's no longer a descendant of the
     trigger's wrapper by the time this fires — query from the document. */
  const sizeGuide = document.querySelector('size-guide');
  if (sizeGuide) sizeGuide.show(trigger);
});
